const areagold = {
  portugues: {
    pageTitle: "Área Gold | Bella da Semana",
    pageDescription:
      "Área exclusiva para assinantes Gold: vote nas suas modelos favoritas e participe das decisões editoriais do Bella da Semana.",
    badge: "ACESSO EXCLUSIVO",
    heroTitle: "PRIVILÉGIO GOLD",
    heroIntro:
      "Apenas assinantes GOLD têm acesso a esta votação exclusiva. Seu voto é importante e ajuda a definir o Ensaio especial do fim de Ano e novos ensaios fotográficos.",
    noPolls: "No momento não há nenhuma votação ativa. Volte em breve!",
    vote: "VOTAR",
    voted: "VOTADO",
    votes: "Votos",
    removeVote: "Remover voto(s)",
    viewEssay: "Ver o ensaio",
    searchPlaceholder: "Buscar modelo...",
    loading: "Carregando...",
    loadError: "Falha ao carregar. Tente novamente.",
    close: "Fechar",
    nextPage: "PRÓXIMA PÁGINA",
    prevPage: "Página anterior",
    gateGuestMessage:
      "Conteúdo exclusivo para assinantes Gold. Faça login para acessar.",
    gateGuestButton: "Entrar / Assinar",
    gateNotGoldMessage:
      "Este espaço é exclusivo para assinantes Gold. Faça upgrade do seu plano e vote nas suas modelos favoritas.",
    gateNotGoldButton: "Quero ser Gold",
    commentsTitle: "Comentários",
    commentYours: "Deixe seu comentário",
    commentPlaceholder: "Escreva seu comentário...",
    commentSend: "Enviar",
    commentAnswer: "Responder",
    commentReplyingTo: "Respondendo a",
    commentCancelReply: "Cancelar",
    commentWroteOn: "escreveu em",
    commentSuccess: "Comentário enviado e aguardando aprovação.",
    commentCaptcha: "Preencha o Recaptcha!",
    commentEmpty: "Escreva um comentário antes de enviar.",
    commentError: "Falha ao enviar comentário!",
    noComments: "Seja o primeiro a comentar.",
    suggestTitle: "Indique uma nova Bella",
    suggestDescription:
      "Indique novas modelos que você queira ver no maior clube masculino de forma anônima. Suas preferências guiam nossas produções!",
    suggestPlaceholder:
      "Insira aqui as informações sobre a modelo como nome, contato ou link para Instagram",
    suggestSend: "Enviar",
    suggestCommentsIntro:
      "As indicações enviadas acima são anônimas e vão direto para a nossa equipe. Use o espaço abaixo para conversar com outros assinantes Gold sobre as modelos que você quer ver por aqui.",
    suggestSuccess: "Indicação enviada com sucesso. Obrigado!",
    suggestEmpty: "Escreva sua indicação antes de enviar.",
    suggestCaptcha: "Preencha o Recaptcha!",
    suggestError: "Falha ao enviar indicação!",
    bannerAlt: "Área exclusiva para assinantes Gold",
  },
  ingles: {
    pageTitle: "Gold Area | Bella Club",
    pageDescription:
      "Exclusive area for Gold subscribers: vote for your favorite models and take part in Bella Club's editorial decisions.",
    badge: "EXCLUSIVE ACCESS",
    heroTitle: "GOLD PRIVILEGE",
    heroIntro:
      "Only GOLD subscribers have access to this exclusive poll. Your vote is important and helps define the special Year-End Shoot and new photo shoots.",
    noPolls: "There are no active polls at the moment. Check back soon!",
    vote: "VOTE",
    voted: "VOTED",
    votes: "Votes",
    removeVote: "Remove vote(s)",
    viewEssay: "View the photo shoot",
    searchPlaceholder: "Search model...",
    loading: "Loading...",
    loadError: "Failed to load. Please try again.",
    close: "Close",
    nextPage: "NEXT PAGE",
    prevPage: "Previous page",
    gateGuestMessage:
      "Exclusive content for Gold subscribers. Log in to access.",
    gateGuestButton: "Login / Subscribe",
    gateNotGoldMessage:
      "This space is exclusive to Gold subscribers. Upgrade your plan and vote for your favorite models.",
    gateNotGoldButton: "I want to be Gold",
    commentsTitle: "Comments",
    commentYours: "Leave your comment",
    commentPlaceholder: "Write your comment...",
    commentSend: "Send",
    commentAnswer: "Reply",
    commentReplyingTo: "Replying to",
    commentCancelReply: "Cancel",
    commentWroteOn: "wrote on",
    commentSuccess: "Comment sent and awaiting approval.",
    commentCaptcha: "Complete the Recaptcha!",
    commentEmpty: "Write a comment before sending.",
    commentError: "Failed to send comment!",
    noComments: "Be the first to comment.",
    suggestTitle: "Suggest a new Bella",
    suggestDescription:
      "Anonymously suggest new models you would like to see in the biggest men's club. Your preferences guide our productions!",
    suggestPlaceholder:
      "Enter here the model's information such as name, contact or Instagram link",
    suggestSend: "Send",
    suggestCommentsIntro:
      "The suggestions sent above are anonymous and go straight to our team. Use the space below to talk with other Gold subscribers about the models you'd like to see here.",
    suggestSuccess: "Suggestion sent successfully. Thank you!",
    suggestEmpty: "Write your suggestion before sending.",
    suggestCaptcha: "Complete the Recaptcha!",
    suggestError: "Failed to send suggestion!",
    bannerAlt: "Exclusive area for Gold subscribers",
  },
};

export default areagold;
